import { Chart } from 'chart.js/auto';
import { state } from '../state.js';
import { bucketKey } from '../utils/date.js';
import { fmtMoney, fmtInt } from '../utils/format.js';
import { montoDisplay } from '../utils/currency.js';
import { getDisplayCurrency } from '../currencyStore.js';

export function renderTrend() {
  const map = new Map();
  state.filtered.forEach((r) => {
    const k = bucketKey(r.FECHA, state.grain);
    if (!map.has(k)) map.set(k, { count: 0, total: 0 });
    const v = map.get(k);
    v.count++;
    v.total += montoDisplay(r);
  });
  const labels = [...map.keys()].filter((k) => k !== '—').sort();
  const counts = labels.map((k) => map.get(k).count);
  const totals = labels.map((k) => map.get(k).total);

  const ctx = document.getElementById('trendChart').getContext('2d');
  if (state.chart) state.chart.destroy();
  state.chart = new Chart(ctx, {
    type: 'line',
    data: {
      labels,
      datasets: [
        { label: `Monto (${getDisplayCurrency()})`, data: totals, borderColor: '#ffffff', backgroundColor: 'rgba(255,255,255,.10)', yAxisID: 'y1', tension: .4, fill: true, pointRadius: 3, borderWidth: 2 },
        { label: '# Ventas', data: counts, borderColor: '#a1a1a1', backgroundColor: 'rgba(161,161,161,.08)', yAxisID: 'y', tension: .4, fill: true, pointRadius: 3, borderWidth: 2 },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      interaction: { mode: 'index', intersect: false },
      plugins: {
        legend: { labels: { color: '#ffffff' } },
        tooltip: {
          callbacks: {
            label: (c) => {
              const v = c.parsed.y;
              return c.dataset.label + ': ' + (c.dataset.yAxisID === 'y1' ? fmtMoney(v) : fmtInt(v));
            },
          },
        },
      },
      scales: {
        x: { ticks: { color: '#a1a1a1' }, grid: { color: 'rgba(255,255,255,.05)' } },
        y: { position: 'left', title: { display: true, text: '# Ventas', color: '#a1a1a1' }, ticks: { color: '#a1a1a1' }, grid: { color: 'rgba(255,255,255,.05)' } },
        y1: { position: 'right', title: { display: true, text: 'Monto', color: '#a1a1a1' }, ticks: { color: '#a1a1a1', callback: (v) => '$' + v }, grid: { display: false } },
      },
    },
  });
}

export function bindGrainButtons(renderTrendCb) {
  document.querySelectorAll('.grain button').forEach((b) => {
    b.onclick = () => {
      document.querySelectorAll('.grain button').forEach((x) => x.classList.remove('active'));
      b.classList.add('active');
      state.grain = b.dataset.grain;
      renderTrendCb();
    };
  });
}
